import React from 'react';
import styled from 'styled-components';
import {ResponsiveContainer, BarChart as RechartBarChart, Bar, Cell, XAxis, YAxis} from 'recharts';

import {getColor} from '../lib/color';
import Number from './Number';
import WidgetHeader from './WidgetHeader'
import Button from './Button';
import Icon from './Icon';

function BarChart({data, total, showGroupValues = false, title, options, id, question, unPin}) {

  let children = [];
  let filteredOptions = options;
  if(question !== undefined) {
    if(question.pinned) {
      children.push(
        <Button id={`${id}_pin`} tertiary onClick={() => unPin(question)}>
          <Icon name="go-pin" />
        </Button>
      )
      filteredOptions = options.filter(option => option.title !== "Pin");
    }
  }

  data = data.filter(a => a.value > 0)
    .sort((a,b) => b.value - a.value)
    .map((data, i) => {
        data.index = i+1;
        return data;
    })

  return (
    <Container>
      <WidgetHeader 
        title={title} 
        options={filteredOptions} 
        id={id} children={children} 
      />
      <ChartCanvas>
        <ResponsiveContainer height="100%">
          <RechartBarChart data={data}>
            <XAxis dataKey="index" />
            <YAxis allowDecimals={false} />
            <Bar dataKey="value" fill="#000">
              {data.map(datum => (
                <Cell key={datum.name} fill={getColor(datum.name)} />
              ))}
            </Bar>
          </RechartBarChart>
        </ResponsiveContainer>
      </ChartCanvas>
      <Groups>
        {data.map(datum => {
          const value = showGroupValues ? <Number>{datum.value}</Number> : `${(datum.value * 100 / total).toLocaleString()}%`;
          
          return (
            <Group key={datum.name}>
              <Indicator color={getColor(datum.name)}>{datum.index}</Indicator>
              <GroupName>{datum.name}</GroupName>
              <GroupValue>{value}</GroupValue>
            </Group>
          );
        })}
      </Groups>
    </Container>
  );
}

const Container = styled.div`
  overflow: hidden;
  height: 100%;
`;

const ChartCanvas = styled.div`
  height: 22rem;
  padding: 0 2rem 1rem 0;
`;

const Groups = styled.div`
  height: 15.75rem;
  overflow: auto;
  padding-bottom: 1rem;
`;

const Group = styled.div`
  padding: 0.25rem 1.875rem 0.25rem 1.875rem;
  display: flex;
  align-items: center;

  :hover {
    background: #f5f5f8;
  }
`;

const Indicator = styled.div`
  background: ${props => props.color};
  width: 2rem;
  height: 2rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 1.5rem;
  margin-right: 0.5rem;
`;

const GroupName = styled.div`
  flex: 1;
`;

const GroupValue = styled.div`
  color: #747474;
`;

export default BarChart;
